<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#2D3436" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/><br/>
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }}</div>
        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-textarea
              v-model="titulo"
              label="Indique la/las cuota/s que abonó; y/o detalle su consulta de pagos"
              required
            >
            </v-textarea>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-file-input
              show-size
              v-model="files"
              :items="files"
              multiple
              counter
              accept="image/*"
              label="Por favor, agregue cualquier Imagen, PDF, etc, de su comprobante de pago"
            >
              <template v-slot:selection="{ text }">
                <v-chip
                  small
                  label
                  close
                  @click:close="remove(index)"
                  color="primary"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
            <v-btn
              color="success"
              elevation="7"
              large
              v-on:click="examen = true"
              @click="addInforme()"
              >Crear informe de pago</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>

import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "InformarPago",
  components: {
    CardIeaAppMain,
  },

  data: () => ({
    title:"Informar pago",
    titulo: '',
    files:[],
  }),

  methods: {
    remove (index) {
      this.files.splice(index, 1)
    },

    async addInforme() {
      if(this.titulo.trim()  == "" ){
        alert('Porfavor, indique la cuota que paga')
        return;
      }
      
      if(this.files.length == 0){
        alert('Porfavor, agregue comprobante de pago')
        return;
      }

      var formData = new FormData();
      formData.append('titulo',this.titulo);
      formData.append('cantidadImagen',this.files.length);

      console.log(this.$refs)
      let i = 0;
      for (let file of this.files) {
          formData.append(`imagen_${i}`, file, file.name);
          i++;
      }
      console.log(formData);
      
      let url = "consulta-acreditacion/store";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.titulo = "";
          this.files = [];
        });
    }
  }
};
</script>
